import { getApiClient } from '@apps/web/lib/api_client';
import { useApiQuery } from '@apps/web/swr_data_fetching/use_api_query';
import {
    type MemoryBackfillDiscardRequest,
    type MemoryBackfillDiscardResponse,
    type MemoryBackfillEnrollRequest,
    type MemoryBackfillParkMembershipRequest,
    type MemoryBackfillPreviewResponse,
    type MemoryBackfillReclassifyParkedRequest,
    type MemoryBackfillReclassifyParkedResponse,
    type MemoryBackfillReleaseRequest,
    type MemoryBackfillReleaseResponse,
    type MemoryBackfillRemoveRequest,
} from '@libraries/typescript/api_client';

const PREVIEW_REFRESH_INTERVAL_MS = 30_000;

export function useMemoryBackfillPreview(organizationId?: string) {
    return useApiQuery<
        '/admin/agent-notes/memory-backfill/preview',
        'get',
        MemoryBackfillPreviewResponse,
        MemoryBackfillPreviewResponse
    >({
        path: '/admin/agent-notes/memory-backfill/preview',
        method: 'get',
        queryParams:
            organizationId === undefined
                ? undefined
                : { organization_id: organizationId },
        mode: 'live',
        select: (response) => response,
        refreshInterval: PREVIEW_REFRESH_INTERVAL_MS,
        refreshWhenHidden: false,
    });
}

export async function enrollMemoryBackfillOrganization(
    body: MemoryBackfillEnrollRequest,
): Promise<MemoryBackfillPreviewResponse> {
    return getApiClient().post({
        url: '/admin/agent-notes/memory-backfill/enroll',
        body,
        mode: 'live',
    });
}

export async function removeMemoryBackfillOrganizations(
    body: MemoryBackfillRemoveRequest,
): Promise<MemoryBackfillPreviewResponse> {
    return getApiClient().post({
        url: '/admin/agent-notes/memory-backfill/remove',
        body,
        mode: 'live',
    });
}

export async function parkMemoryBackfillOrganizations(
    body: MemoryBackfillParkMembershipRequest,
): Promise<MemoryBackfillPreviewResponse> {
    return getApiClient().post({
        url: '/admin/agent-notes/memory-backfill/park',
        body,
        mode: 'live',
    });
}

export async function unparkMemoryBackfillOrganizations(
    body: MemoryBackfillParkMembershipRequest,
): Promise<MemoryBackfillPreviewResponse> {
    return getApiClient().post({
        url: '/admin/agent-notes/memory-backfill/unpark',
        body,
        mode: 'live',
    });
}

export async function releaseMemoryBackfillItems(
    body: MemoryBackfillReleaseRequest,
): Promise<MemoryBackfillReleaseResponse> {
    return getApiClient().post({
        url: '/admin/agent-notes/memory-backfill/release',
        body,
        mode: 'live',
    });
}

export async function reclassifyParkedMemoryBackfillNotes(
    body: MemoryBackfillReclassifyParkedRequest,
): Promise<MemoryBackfillReclassifyParkedResponse> {
    return getApiClient().post({
        url: '/admin/agent-notes/memory-backfill/reclassify-parked',
        body,
        mode: 'live',
    });
}

export async function discardMemoryBackfillWork(
    body: MemoryBackfillDiscardRequest,
): Promise<MemoryBackfillDiscardResponse> {
    return getApiClient().post({
        url: '/admin/agent-notes/memory-backfill/discard',
        body,
        mode: 'live',
    });
}
